import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import { UPGRADE_MODALS_IDENTIFIER } from '../../../services/Constants';
import { onboardingModalActionTypes } from './Constants';
import * as onboardingModalActions from './Actions';
import * as sharedActions from '../../../pagesNext/shared/Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';
import * as sidebarActions from '../../sideBar/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			onboardingModalActionTypes.GET_ONBOARDING_MODAL_REQUEST,
			handleGetOnboardingModalRequest,
		),
	]);
}

export function* handleGetOnboardingModalRequest({ payload }) {
	try {
		const { data: requestData } = payload;

		const { data } = yield call(
			processRequest,
			`public/explanation_blocks/${requestData.identifier}`,
			'GET',
			requestData.variantIdentifier && { variant_identifier: requestData.variantIdentifier },
		);

		yield put(
			onboardingModalActions.getOnboardingModalSuccess({
				data: data.explanation_blocks,
				open: !data.explanation_blocks[0].usps,
				isOpenUpgradePrompt: data.explanation_blocks[0].usps,
			}),
		);
		yield put(
			sharedActions.setUpgradeModalIdentifier({
				upgradeModalIdentifier: `${UPGRADE_MODALS_IDENTIFIER.UPGRADE_MESSAGE}_${requestData.identifier}`,
			}),
		);
	} catch (e) {
		if (e.response.status === 422) {
			yield put(sidebarActions.getUseDataRequest());
		}
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(onboardingModalActions.getOnboardingModalError(e));
	}
}
